import React from "react";
import { HorizontalSlider } from "../../HorizontalSlider";
import { TextSC, VolumeCrossSC } from "./styled";
import { useIsEnglishUi } from "utils/uiLanguage";

export interface VolumeCrossProps {
  volumeTranslated: number;
  volumeOriginal: number;
  setVolumeOriginal: (volumeOriginal: number) => void;
  setVolumeTranslated: (volumeTranslated: number) => void;
}

export function VolumeCross({
  volumeTranslated,
  setVolumeTranslated,
  volumeOriginal,
  setVolumeOriginal,
}: VolumeCrossProps) {
  const en = useIsEnglishUi();
  return (
    <>
      <VolumeCrossSC>
        <TextSC>{en ? "Translation" : "Перевод"} ({volumeTranslated})</TextSC>
        <HorizontalSlider
          width={200}
          min={0}
          max={100}
          value={volumeOriginal}
          onValueChange={(val) => {
            setVolumeOriginal(val);
            setVolumeTranslated(100 - val);
          }}
        />
        <TextSC>{en ? "Original" : "Оригинал"} ({volumeOriginal})</TextSC>
      </VolumeCrossSC>
    </>
  );
}
